module.exports = __webpack_public_path__ + "img/gb9114_1.prt.5652ac5a.jpg";